import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PageContainer from '../common/PageContainer';
import * as selectors from '../../redux/selectors';
import * as actions from '../../redux/actions';
import { bindActionCreators } from 'redux';
import { Breadcrumb, Button, Form, Icon, Image, Menu, Segment } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import './photo.scss';
import { TextField } from '../common/FormFields';
import { Formik } from 'formik';
import CloudinaryUploadWidget from '../showcase/CloudinaryUploadWidget';

const EditPhotoPage = ({ match, getPhotoById, current, searchPhotos, getUsers, updatePhoto }) => {
  const id = match.params.id;
  const [imageUrl, setImageUrl] = useState('');

  useEffect(() => {
    getPhotoById(id);
    getUsers();
  }, [id]);

  useEffect(() => setImageUrl(current?.url?.medium), [current]);

  const getPage = () => (
    <PageContainer>
      <Formik initialValues={current} enableReinitialize onSubmit={updatePhoto}>
        {formik => (
          <>
            <Breadcrumb>
              <Breadcrumb.Section>Photos</Breadcrumb.Section>
              <Breadcrumb.Divider icon="right angle" />
              <Breadcrumb.Section>
                <Link to="/photos">Search</Link>
              </Breadcrumb.Section>
              <Breadcrumb.Divider icon="right angle" />
              <Breadcrumb.Section>Edit</Breadcrumb.Section>
            </Breadcrumb>

            <Menu borderless>
              <Menu.Item header>
                <Icon name="photo" />
                Edit Photo
              </Menu.Item>

              <Menu.Menu position="right">
                <Menu.Item>
                  <Button content="Save" icon="save" positive onClick={formik.handleSubmit} />
                </Menu.Item>
              </Menu.Menu>
            </Menu>

            <Segment>
              <Image
                src={`${imageUrl}`}
                size="large"
                target="_blank"
                as="a"
                href={current?.url ? current?.url?.original : imageUrl}
              />

              <br />
              <br />
              <CloudinaryUploadWidget
                formik={formik}
                fieldName={'original'}
                fullMenu
                onSuccess={({ url }) => {
                  console.log(url);
                  formik.setFieldValue('original', url);
                  setImageUrl(`https://res.cloudinary.com/culturemap-com/${url}`);
                }}
              />
              <br />
              <br />
              <Form>
                <Form.Field>
                  <label>Alt tag</label>
                  <TextField
                    formik={formik}
                    id="altTag"
                    name="altTag"
                    onChange={formik.handleChange}
                    value={formik.values.altTag}
                  />
                </Form.Field>
                <Form.Group widths="equal">
                  <Form.Field>
                    <label>Credit</label>
                    <TextField
                      formik={formik}
                      id="credit"
                      name="credit"
                      onChange={formik.handleChange}
                      value={formik.values.credit}
                    />
                  </Form.Field>
                  <Form.Field>
                    <label>Credit URL</label>
                    <TextField
                      formik={formik}
                      id="creditUrl"
                      name="creditUrl"
                      onChange={formik.handleChange}
                      value={formik.values.creditUrl}
                    />
                  </Form.Field>
                </Form.Group>
                <Form.Field>
                  <label>Tags</label>
                  <TextField
                    formik={formik}
                    id="tags"
                    name="tags"
                    onChange={formik.handleChange}
                    value={formik.values.tags}
                  />
                </Form.Field>
              </Form>
            </Segment>
          </>
        )}
      </Formik>
    </PageContainer>
  );

  return <>{current?.id && getPage()}</>;
};

const mapStateToProps = state => ({
  current: selectors.photos.current(state),
  count: selectors.photos.count(state),
  page: selectors.photos.page(state),
  photos: selectors.photos.photos(state),
  users: selectors.photos.userOptions(state),
});

const mapDispatchToProps = dispatch => ({
  getPhotos: bindActionCreators(actions.photos.getPhotos, dispatch),
  getPhotoById: bindActionCreators(actions.photos.getPhotoById, dispatch),
  searchPhotos: bindActionCreators(actions.photos.searchPhotos, dispatch),
  getUsers: bindActionCreators(actions.photos.getUsers, dispatch),
  setPhotoPage: bindActionCreators(actions.photos.setPhotoPage, dispatch),
  updatePhoto: bindActionCreators(actions.photos.updatePhoto, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditPhotoPage);
